<div class="form-group">
    <div class="input-group">
        <button
            class="btn btn-outline-secondary"
            (click)="datePicker.toggle()"
            [disabled]="disabled"
        >
            <nb-icon icon="fa-calendar"></nb-icon>
        </button>
        <input
            readonly
            class="form-control"
            placeholder="jj/mm/aaaa"
            name="beginDate"
            (blur)="dateBlurred()"
            (dateSelect)="dateChanged()"
            [(ngModel)]="selectedDate"
            [container]="'body'"
            ngbDatepicker
            #datePicker="ngbDatepicker"
        />
    </div>
</div>
